import { z } from 'zod';

import { Address } from '../Address';
import { BorrowerPreferences, CitizenshipStatus, Ethnicity, FicoScore, Gender } from '../Borrower';
import { Phone } from '../Phone';

export const BorrowerApi = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().optional(),
  phoneNumbers: Phone,
  isPrimary: z.boolean(),
  settings: z.object({
    emailConsent: z.boolean(),
    phoneConsent: z.boolean(),
    emailNotificationsEnabled: z.boolean(),
    paperNotificationsEnabled: z.boolean(),
    mailingAddress: Address.optional(),
    preferences: BorrowerPreferences.optional(),
    citizenshipStatus: CitizenshipStatus.optional(),
    scraFlag: z.boolean().optional(),
    vip: z.boolean().optional(),
    ficoScore: FicoScore.optional(),
    dob: z.iso.datetime().optional(),
    gender: Gender.optional(),
    ethnicity: Ethnicity.optional(),
  }),
});
export type BorrowerApi = z.infer<typeof BorrowerApi>;
